import { createAction } from "@reduxjs/toolkit";

import {
  getNotificationsSettingsActionTypes,
  updateNotificationsSettingsActionTypes,
  clearNotificationsSettingsActionTypes,
} from "./actionTypes";

export const getNotificationsSettings = createAction(
  getNotificationsSettingsActionTypes.request,
);

export const getNotificationsSettingsSuccess = createAction(
  getNotificationsSettingsActionTypes.success,
  (payload) => ({ payload }),
);

export const getNotificationsSettingsFailure = createAction(
  getNotificationsSettingsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const updateNotificationsSettings = createAction(
  updateNotificationsSettingsActionTypes.request,
);

export const updateNotificationsSettingsSuccess = createAction(
  updateNotificationsSettingsActionTypes.success,
  (payload) => ({ payload }),
);

export const updateNotificationsSettingsFailure = createAction(
  updateNotificationsSettingsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const clearNotificationsSettingsStates = createAction(
  clearNotificationsSettingsActionTypes.reset,
);
